import React from 'react'
import PropTypes from 'prop-types'

import Icon from '../../../Shared/Icon/Icon'

function EmptyBuyerSection({ title }) {
  return (
    <div className="projects-empty__usp">
      <div className="container-fixed">
        <div className="row">
          <div className="col-12">
            <h4 className="heading-24">{title}</h4>
          </div>
          <div className="col-12 col-sm-6 col-md-3 projects-empty__usp-block">
            <Icon type={['fal', 'badge-check']} size="4x" color="green-dark" />
            <h5 className="heading-18">Guaranteed quality</h5>
            <p>CGTrader assures that the result will meet your requirements, be delivered on time, and is ready to step in at any point.</p>
          </div>
          <div className="col-12 col-sm-6 col-md-3 projects-empty__usp-block">
            <Icon type={['fal', 'bullseye']} size="4x" color="green-dark" />
            <h5 className="heading-18">Targeted community</h5>
            <p>Home to tens of thousands of designers, CGTrader is the best place for any 3D Project.</p>
          </div>
          <div className="col-12 col-sm-6 col-md-3 projects-empty__usp-block">
            <Icon type={['fal', 'address-card']} size="4x" color="green-dark" />
            <h5 className="heading-18">Know your contractor</h5>
            <p>Easily review your applicant’s portfolio on CGTrader.</p>
          </div>
          <div className="col-12 col-sm-6 col-md-3 projects-empty__usp-block">
            <Icon type={['fal', 'usd-circle']} size="4x" color="green-dark" />
            <h5 className="heading-18">No listing fees</h5>
            <p>Completely free to create and post as many freelance 3D Projects as you need.</p>
          </div>
        </div>
      </div>
    </div>
  )
}

EmptyBuyerSection.propTypes = {
  title: PropTypes.string.isRequired,
}

export default EmptyBuyerSection
